import * as Connector from 'shared/connectors/partnerConnector';
import { PARTNER } from 'store/types';

const init = () => ({
  type: PARTNER.GET_ARCHIVED_PARTNERS_INIT,
});

export const success = data => ({
  type: PARTNER.GET_ARCHIVED_PARTNERS_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: PARTNER.GET_ARCHIVED_PARTNERS_FAILURE,
});

const getArchivedPartners = () => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getArchivedPartners();
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getArchivedPartners;
